import { render, staticRenderFns } from "./ThreeCardBlueLayout.vue?vue&type=template&id=2b072e4d&scoped=true"
var script = {}
import style0 from "./ThreeCardBlueLayout.vue?vue&type=style&index=0&id=2b072e4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b072e4d",
  null
  
)

export default component.exports